import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { Bar, Line, Doughnut, Pie } from 'react-chartjs-2';
import './Dashboard.css'; // Import the CSS file for layout styling

// Register the required components
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const Dashboard = () => {
    // Dummy data for the charts
    const data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                label: 'Sales',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const pieData = {
        labels: ['Red', 'Blue', 'Yellow'],
        datasets: [
            {
                data: [300, 50, 100],
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
            },
        ],
    };

    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Dashboard</h2>
            <div className="dashboard-charts">
                <div className="chart-container">
                    <Bar data={data} options={{ responsive: true }} />
                    <p className="chart-title">Sales Bar Chart</p>
                </div>
                <div className="chart-container">
                    <Line data={data} options={{ responsive: true }} />
                    <p className="chart-title">Sales Line Chart</p>
                </div>
                <div className="chart-container">
                    <Doughnut data={pieData} options={{ responsive: true }} />
                    <p className="chart-title">Doughnut Chart</p>
                </div>
                <div className="chart-container">
                    <Pie data={pieData} options={{ responsive: true }} />
                    <p className="chart-title">Pie Chart</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
